export const makeOptionsForSelect = (data) => {
  const options = data ? data.map(opt => ({
    value: opt.id,
    label: opt.description || opt.name,
  })) : []

  return options
}